import { IQuoteSection } from 'types/quote'
import InfoArea from './InfoArea'

const Second = ({ quoteInfo }: IQuoteSection) => {
    return (
        <div className='bg-white border-[#9D9EB7] border-1 rounded-lg'>
            <div className='bg-[#F8F8FA] px-10 py-6 rounded-t-lg'>
                <p className='font-semibold text-2xl'>인코텀즈</p>
            </div>

            <div className='flex flex-col gap-6 px-10 py-6'>
                <InfoArea
                    title='종류'
                    value={quoteInfo.step2?.incoterms}
                />
                {
                    quoteInfo.step2?.deliveryAddress &&
                    <InfoArea
                        title='입고지 정보'
                        value={`${quoteInfo.step2?.deliveryAddress} ${quoteInfo.step2?.deliveryAddressDetail}`}
                    />
                }
            </div>
        </div >
    )
}

export default Second